// @flow
import React, {useEffect, useState} from "react";
import ArchiverClientApi from "../API/archiverClientApi";
import Header from "./Header";
import BackButton from "../GUI_COMMON/COMPONENTS/BackButton";
import LoadingSpinner from "../GUI_COMMON/COMPONENTS/LoadingSpinner";
import PrintLabelsForm from "./PrintLabelsForm";
import ReprintLabelsForm from "./ReprintLabelsForm";
import ArchiverGuiUtils from "../SUPPORT/ArchiverGuiUtils";
import ReprintBoxLabelsForm from "./ReprintBoxLabelsForm";
import ErrorPopup from "../GUI_COMMON/COMPONENTS/ErrorPopup";

const PrintLabelsPage = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPrinters, setIsLoadingPrinters] = useState(false);
    const [devices, setDevices] = useState([]);
    const [printerDevices, setPrinterDevices] = useState([]);
    const [selectedPrinter, setSelectedPrinter] = useState({});

    useEffect(() => {
        console.debug("PrintLabelsPage starting up...");
        setIsLoading(true);
        setIsLoadingPrinters(true);
        ArchiverClientApi.getMagableDevices()
        .then((response) => {
            setDevices(response);
            ArchiverClientApi.getPrinterDevices()
            .then((response) => {
                setPrinterDevices(response);
                setSelectedPrinter(response[0]??{}); // the entire device object is stored in the state
            })
            .catch( responseError => {
                if(responseError.statusCode===404) {
                    ErrorPopup.showError("Error", "No printer devices found. Please check the printer configuration.");
                }
                else { // some other error
                    ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError);
                }
            });
        })
        .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
        .finally( () => {
            setIsLoading(false)
            setIsLoadingPrinters(false);
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    function showPrinterOptions() {
        const printerList = printerDevices.map((printer) => {
            return <option key={printer.id} value={printer.id}>{printer.fullName}</option>;
        });
        return <><option key={-1} value={-1} disabled>(select a printer)</option>{printerList}</>;
    }

    function handlePrinterSelect(event) {
        const printerDeviceId = Number(event.target.value);
        const printerDevice = printerDevices.find((device) => device.id === printerDeviceId)??"";
        console.debug("Printer device set to: " + printerDevice.id);
        setSelectedPrinter(printerDevice);
    }

    function showPrinterList() {
        if (isLoadingPrinters) {
            return <LoadingSpinner small/>;
        }
        return (
            <div className="d-inline-block">
                <select id="printerSelect" className="form-control" onSelect={handlePrinterSelect}
                        onChange={handlePrinterSelect} value={selectedPrinter?.id??-1}>{showPrinterOptions()}</select>
            </div>
        );
    }

    return (
        <div className="container">
            <Header/>
            <div className="row li-header-row m-0 p-0 justify-content-between">
                <div className="align-self-center">
                    <BackButton/>
                    <h1 className="d-inline-block align-middle">Print Labels</h1>
                </div>
                <div className="mr-3 align-self-center">
                    <li className="mr-3 fa fa-print fa-2x align-middle"/>
                    {showPrinterList()}
                </div>
            </div>

            {isLoading && <LoadingSpinner medium center/>}
            {!isLoading &&
            <>
                <PrintLabelsForm devices={devices} destinationPrinterDevice={selectedPrinter}/>
                <div className="li-border-line my-4"/>
                <ReprintLabelsForm destinationPrinterDevice={selectedPrinter}/>
                <div className="li-border-line my-4"/>
                <ReprintBoxLabelsForm destinationPrinterDevice={selectedPrinter}/>
            </>
            }
        </div>
    );
}

PrintLabelsPage.propTypes = {}

export default PrintLabelsPage;